module.exports = __webpack_public_path__ + "static/jigyo1-b93e918ea80a9f2934c9b2ba573f1b5a.jpg";